export default "__VITE_ASSET__cc07b830__"